var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shipping-wrap border-top"},[_c('div',{staticClass:"anchor",attrs:{"id":"ShippingAnchorId"}}),_c('div',{staticClass:"module-title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }